import { z } from 'zod';

export const companySchema = z.object({
  tag: z.string(),
  name: z.string(),
  ticker: z.string(),
  exchange: z.string(),
  evidence: z.string(),
});
export type Company = z.infer<typeof companySchema>;

export const companyArrSchema = z.array(companySchema);

const createPath =
  (type: string) =>
  ({ tag, limit, isEtf }: { tag: string; limit?: number; isEtf?: boolean }) => {
    const search = limit ? `?limit=${limit}` : '';
    const assetType = isEtf ? 'fund' : 'company';
    return `ontology/v1/${assetType}/${tag}/${type}${search}`;
  };

export const ontology = {
  /**
   * @deprecated
   */
  getCompetitors: {
    path: createPath('competitors'),
    schema: companyArrSchema,
  },
};
